import React, { FC } from 'react';

import { Radio } from './components/Radio';
import { Label, RadioRow } from './styles';

interface RadioOptionProps {
  value?: boolean;
  label: string;
  selected?: boolean;
  error?: string;
  onValueSelected: (selected: boolean) => void;
}

export const RadioOption: FC<RadioOptionProps> = ({
  value,
  label,
  error,
  selected,
  onValueSelected,
}) => {
  const testID = label.replace(' ', '-').toLowerCase();

  return (
    <RadioRow id={`${testID}-radio-row`} data-testid={`${testID}-radio-row`}>
      <Radio
        name={testID}
        value={value}
        label={label}
        selected={selected}
        error={!!error}
        onValueSelected={onValueSelected}
      />
      <Label>{label}</Label>
    </RadioRow>
  );
};

RadioOption.defaultProps = {
  value: undefined,
  selected: undefined,
  error: null,
};
